<template>
    <div id="payout_payza_component"
         class="payout-option-outer">
        <p>Payza</p>
        <p style="margin-bottom: 15px">Security check:</p>
        <b-row class="payout-option-inner">
            <futuro-network-password :sending="sending"
                                     :show-errors="showErrors"
                                     :set-value="setValue"></futuro-network-password>
        </b-row>
        <b-row class="payout-option-inner">
            <b-col lg="6">
                <autocomplete-component :default-value="''"
                                        :field-key="'country'"
                                        :label="'Country'"
                                        :list="countries"
                                        :rules="{ required: true, isOnList: [countries] }"
                                        :show-errors="showErrors"
                                        :update-value="setValue"></autocomplete-component>
            </b-col>
        </b-row>
        <b-row class="payout-option-inner">
            <payza-email :sending="sending"
                         :show-errors="showErrors"
                         :set-value="setValue"></payza-email>
        </b-row>
    </div>
</template>

<script>
    import FuturoNetworkPassword from './common/FuturoNetworkPassword.vue'
    import PayzaEmail from './payza/PayzaEmail.vue'

    export default {
        inject: ['$validator'],
        props: ['countries', 'sending', 'showErrors', 'setValue'],
        components: { FuturoNetworkPassword, PayzaEmail }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/payout/Payza.vue